// Showing New remainder Icon for rejected Mobile CRQs
import React from 'react';
import { InformationCircle } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/info-error.css';

const InfoIcon = React.memo(() => (
  <div className="section-info-wrapper summary-info-wrapper">
    <div className="section-info">
      <div className="info-svg-wrapper">
        <div className="info-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="info-message">
        <p>Please ensure you have checked for impacts on the Install Plan/MOP and added an updated Install Plan/MOP.</p>
      </div>
    </div>
  </div>
));

const InfoIconSIA = React.memo(() => (
  <div className="sia-msg-outer section-info-wrapper summary-info-wrapper">
    <div className="section-info">
      <div className="info-svg-wrapper">
        <div className="info-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="info-message">
        <p>The submit button will be enabled after Remedy attaches the report of Service Impact Assessment file.</p>
        <p>Please refresh the page and check again in sometime.</p>
      </div>
    </div>
  </div>
));

const InfoIconClone = () => (
  <div className="sia-msg-outer section-info-wrapper summary-info-wrapper">
    <div className="section-info">
      <div className="info-svg-wrapper">
        <div className="info-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="info-message">
        <p>Notes: We are using the existing date and summary. Once duplicate CRQ has been created you will be able to edit the details.</p>
      </div>
    </div>
  </div>
);

const InfoIconEmergency = React.memo(() => (
  <div className="section-info-wrapper summary-info-wrapper">
    <div className="section-info">
      <div className="info-svg-wrapper">
        <div className="info-svg">
          <InformationCircle />
        </div>
      </div>
      <div className="info-message">
        <p>
          Please ensure you have added the INC Number as Mandatory while
          creating the Emergency Change
        </p>
      </div>
    </div>
  </div>
));

export {
  InfoIcon,
  InfoIconSIA,
  InfoIconClone,
  InfoIconEmergency,
};
